import { gql, TypedDocumentNode } from "@apollo/client";

import {
  SendCompanionSessionMessageMutation,
  SendCompanionSessionMessageMutationVariables,
} from "./SendCompanionSessionMessage.generated";

export const SEND_COMPANION_SESSION_MESSAGE: TypedDocumentNode<
  SendCompanionSessionMessageMutation,
  SendCompanionSessionMessageMutationVariables
> = gql`
  mutation sendCompanionSessionMessage(
    $textContent: String!
    $companionSessionUuid: String!
    $streamingTaskUuid: String
    $noteUuid: String
    $templateUuid: String
  ) {
    sendCompanionSessionMessage(
      textContent: $textContent
      companionSessionUuid: $companionSessionUuid
      streamingTaskUuid: $streamingTaskUuid
      noteUuid: $noteUuid
      templateUuid: $templateUuid
    ) {
      ok
    }
  }
`;
